import * as t from 'io-ts'
import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

export const Signer = t.type(
  {
    id: t.string,
    applicationId: t.string,
    signedAt: tv.dateTimeFromString,
    signedBy: t.string,
    ssnHash: t.string
  },
  'Signer'
)

export type Signer = t.TypeOf<typeof Signer>
